import axios from "axios";

export const api = axios.create({
  baseURL: "https://sistema.miltecti.com.br/monitoramentoapi",
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwtToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
